<template>
  <AvailabilityInformation v-bind="$props">
    <template
      v-if="!availability?.stock"
      #delivery-availability-mail
    >
      <DeliveryAvailabilityMailContainer :article-number="articleNumber" />
    </template>
  </AvailabilityInformation>
</template>

<script>
import { AvailabilityInformation } from '@i22/td-longtail-vue-components';
import DeliveryAvailabilityMailContainer from '~/components/product-detail/delivery-availability-mail-container.vue';

export default {
  name: 'AvailabilityInformationContainer',
  components: {
    AvailabilityInformation,
    DeliveryAvailabilityMailContainer,
  },
  props: {
    isPresale: {
      type: Boolean,
    },
    articleNumber: {
      type: String,
      required: true,
    },
    availability: {
      type: Object,
      default: undefined,
    },
  },
};
</script>
